<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('decision.time') }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('member.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>

        <div class="item">
          <span class="label">{{ $t('order.no') }}</span>
          <el-input class="inp" size="small" v-model="formData.valOrderSn"
            :placeholder="$t('order.inp.order_no')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.no') }}</span>
          <el-input class="inp" size="small" v-model="formData.valDeviceId"
            :placeholder="$t('order.inp.device_no')"></el-input>
        </div>
        <!-- <div class="item">
          <span class="label">{{ $t('order.site_name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valSiteName"
            :placeholder="$t('order.site_name')"></el-input>
        </div> -->
        <div class="item">
          <span class="label">{{ $t('order.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valTel" :placeholder="$t('order.inp.name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.site_name') }}</span>
          <el-select class="inp" v-model="formData.SiteName" :placeholder="$t('g.choose')" clearable size="small">
            <el-option v-for="(item, index) in formData.pilesiteList" :key="index" :label="item.Name"
              :value="item.Name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.exportAllExcel()" class="btn-export" type="info">{{ $t('g.export') }}</el-button>
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" @row-click="func.showDetails" style="width: 100%"
        :summary-method="func.getSummaries" show-summary>
        <el-table-column prop="OrderSn" :label="$t('order.no')" width="200">
        </el-table-column>
        <el-table-column prop="AgentCode" :label="$t('g.agent_code')" width="80">
        </el-table-column>

        <el-table-column prop="UserInfo.Nickname" width="120" :label="$t('bill.nickname')">
        </el-table-column>
        <el-table-column prop="DeviceId" min-width="240" :label="$t('device.no')">
        </el-table-column>
        <el-table-column prop="DeviceSiteName" min-width="120" :label="$t('device.site_name')">
        </el-table-column>
        <el-table-column width="80" :label="$t('member.status')">
          <template #default="scope">
            <el-tag :class="scope.row.StatusClass">
              {{ scope.row.StatusStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="110" :label="$t('order.PaymentStatus.name')">
          <template #default="scope">
            <el-tag :class="scope.row.payStatusClass">
              {{ scope.row.payStatusStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="UserMoney" width="110" :label="$t('member.balance')">
        </el-table-column>
        <el-table-column prop="ChargeBatteryOrderInfo.ChargeMoney" width="110" :label="$t('order.moneys.charge')">
        </el-table-column>
        <el-table-column prop="ChargeBatteryOrderInfo.ChargeDuration" width="110" :label="$t('order.charge_duration')">
        </el-table-column>
        <el-table-column prop="ChargeBatteryOrderInfo.SlotId" width="60" :label="$t('order.pilePosition')">
        </el-table-column>
        <el-table-column width="100" :label="$t('device.prices.charge')">
          <template #default="scope">
            <span v-if="scope.row.ChargeBatteryOrderInfo.ChargeType == 3">  {{ scope.row.ChargeBatteryOrderInfo.ChargePerMoney}}{{ $t('billingPolicy.settings_txt5') }}</span>
            <span v-else>{{ scope.row.ChargeBatteryOrderInfo.ChargePerMoney }}{{$t('device.price_unit')}}</span>
          </template>
        </el-table-column>
        <el-table-column width="150" :label="$t('device.chargedEnergy')">
          <template #default="scope">
            <span v-if="scope.row.ChargeBatteryOrderInfo.ChargeType == 3">
              {{ scope.row.ChargeBatteryOrderInfo?.ChargePower/1000  }}{{$t('g.unit_kwh')}} 
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="CreatedAtStr" min-width="200" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column prop="NamePath" min-width="180" :label="$t('g.operator_ownership')"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column width="140" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <!-- <el-tag v-if="scope.row.ChargeBatteryOrderInfo.ChargeStatus != 3" type="danger"
              @click="func.tapStatus(scope.row)" >
              {{ $t('order.end') }}
            </el-tag> -->
            <el-button v-if="scope.row.ChargeBatteryOrderInfo.ChargeStatus != 3" @click="func.tapStatus(scope.row)"
              class="btn-delete" type="primary">{{ $t('order.end') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <div class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize }}
        </div>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" align-center>
      <el-descriptions border column="2">
        <el-descriptions-item :label="$t('order.no')">{{ formData.curData.OrderSn }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.agent_code')" v-if="!isOperator()">{{ formData.curData.AgentCode
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('bill.nickname')">
          <el-link type="primary" @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Nickname
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('device.no')">
          <el-link type="primary" @click="formData.pileDrawerVisible = true">{{ formData.curData.DeviceId
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('device.site_name')">{{ formData.curData.DeviceSiteName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.status')"> <el-tag :class="formData.curData.StatusClass">
            {{ formData.curData.StatusStr }}
          </el-tag></el-descriptions-item>

        <el-descriptions-item :label="$t('order.PaymentStatus.name')"><el-tag :class="formData.curData.payStatusClass">
            {{ formData.curData.payStatusStr }}
          </el-tag></el-descriptions-item>
        <!-- <el-table-column prop="payStatusStr" width="110" :label="$t('order.PaymentStatus.name')">
        </el-table-column> -->
        <el-descriptions-item :label="$t('order.moneys.charge')">{{ formData.curData.ChargeBatteryOrderInfo.ChargeMoney
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.charge_duration')">{{
          formData.curData.ChargeBatteryOrderInfo.ChargeDuration
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.pilePosition')">{{ formData.curData.ChargeBatteryOrderInfo.SlotId
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.prices.charge')">
          <span v-if="formData.curData.ChargeBatteryOrderInfo?.ChargeType == 3"> {{ formData.curData.ChargeBatteryOrderInfo?.ChargePerMoney }}{{ $t('billingPolicy.settings_txt5') }}</span>
          <span v-else>{{ formData.curData.ChargeBatteryOrderInfo?.ChargePerMoney }}{{$t('device.price_unit')}} </span> 
        </el-descriptions-item>
        <el-descriptions-item v-if="formData.curData.ChargeBatteryOrderInfo?.ChargeType == 3" :label="$t('device.chargedEnergy')">
          {{ formData.curData.ChargeBatteryOrderInfo?.ChargePower/1000  }}{{$t('g.unit_kwh')}} 
        </el-descriptions-item>
        <el-descriptions-item :label="$t('member.balance')">{{ formData.curData.UserMoney }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreatedAtStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.times.charge_start')">{{
          formData.curData.ChargeBatteryOrderInfo.StartTimeStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.times.charge_end')">{{
          formData.curData.ChargeBatteryOrderInfo.EndTimeStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.power_level')">{{
          formData.curData.ChargeBatteryOrderInfo.OriginPowerLevel
        }}W</el-descriptions-item>
        <el-descriptions-item :label="$t('order.site_name')">{{ formData.curData.DeviceSiteName
        }}</el-descriptions-item>
        <el-descriptions-item label="充电模式">{{ formData.curData.ChargeBatteryOrderInfo.ChargeMode == 1 ? '自动充满' : '时长充电'
        }}</el-descriptions-item>
        <el-descriptions-item label="预定充电时长">{{ func.formatSecToStr(formData.curData.ChargeBatteryOrderInfo.ChargeData)
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.end_reason')" v-if="formData.curData.EndReason">{{
          formData.curData.EndReason }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.failed_reason')" v-if="formData.curData.FailReason">{{
          formData.curData.FailReason }}</el-descriptions-item>
        <el-descriptions-item :label="$t('invoiceOrder.issue')">{{
          formData.curData.ChargeBatteryOrderInfo.IsInvoice != 1 ? $t('g.no') : $t('g.yes')
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.remark')" v-if="formData.curData.ChargeBatteryOrderInfo.Remark">{{
          formData.curData.ChargeBatteryOrderInfo.Remark }}</el-descriptions-item>

      </el-descriptions>
    </el-dialog>
    <el-drawer v-model="formData.userDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <MemberList :propId="formData.curData.UserInfo.Id"></MemberList>
    </el-drawer>
    <el-drawer v-model="formData.pileDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <CPileboxList :propId="formData.curData.DeviceId"></CPileboxList>
    </el-drawer>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import axios from 'axios'
import { operators, updateOperators, shortcuts, cascade_options_direct } from '@/data/default'
import { ElMessageBox, ElMessage, ElLoading } from 'element-plus'
import { toDay } from "@/common/func"
import i18n from '@/data/i18n/index'
import { isOperator } from '@/data/token'
import * as XLSX from 'xlsx/xlsx.mjs'
import MemberList from '@/views/member/list.vue'
import CPileboxList from '@/views/pile/list.vue'

export default {
  name: 'OrderPile',
  components: {
    MemberList,
    CPileboxList
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('member.statuses.all'),
        value: 2
      },
      {
        label: t('member.statuses.waiting'),
        value: 0
      },
      {
        label: t('member.statuses.charging'),
        value: 1
      },
      {
        label: t('member.statuses.completed'),
        value: 3
      },
      {
        label: t('member.statuses.failed'),
        value: 99
      }
    ]
    const render = {
      shortcuts,
      statuses,
      operators,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      CodePathID: 0,
      valStatus: 2,
      valTime: '',
      valTel: '',
      valOrderSn: '',
      dialogDisplayVisible: false,
      pileDrawerVisible: false,
      userDrawerVisible: false,
      valDeviceId: '',
      valSiteName: '',
      // pagination
      curPage: 1,
      pageSize: 10,
      total: 1,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      IsStartWith: 1,
      pilesiteList: [],
      SiteName: ''
    })
    const func = {
      async exportAllExcel() {
        try {
          let params = {
            isExport: true,
          }
          if (formData.valOrderSn) {
            params.orderSn = formData.valOrderSn
          }
          if (formData.valDeviceId) {
            params.deviceId = formData.valDeviceId
          }
          if (formData.valSiteName) {
            params.siteName = formData.valSiteName
          }
          if (formData.valPhone) {
            params.phoneNum = formData.valPhone
          }
          if (formData.CodePathID) {
            params.CodePathID = formData.CodePathID
          }
          if (formData.valTel) {
            params.nickname = formData.valTel
          }
          if (formData.valStatus != 2) {
            params.status = formData.valStatus
          }
          if (formData.SiteName) {
            params.SiteName = formData.SiteName
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          params.IsStartWith = formData.IsStartWith
          let loading = ''
          loading = ElLoading.service({
            lock: true,
            text: t('openSlotsLit.loading'),
            background: 'rgba(0, 0, 0, 0.7)',
          })
          let res = await axios.get(`/admin/order/spiCharge`, {
            params
          })

          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreatedAt)
            item.ChargeBatteryOrderInfo.TakeBatteryTimeStr = item.ChargeBatteryOrderInfo.TakeBatteryTime ? toDay(item.ChargeBatteryOrderInfo.TakeBatteryTime) : "-"
            item.ChargeBatteryOrderInfo.StartTimeStr = item.ChargeBatteryOrderInfo.StartTime ? toDay(item.ChargeBatteryOrderInfo.StartTime) : "-"
            item.ChargeBatteryOrderInfo.EndTimeStr = item.ChargeBatteryOrderInfo.EndTime ? toDay(item.ChargeBatteryOrderInfo.EndTime) : "-"
            if (item.DeviceStatus === 0) {
              item.StatusStr = t('member.statuses.failed')
              item.StatusClass = "tag-fail"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 0) {
              item.StatusStr = t('order.ps.unresponsive')
              item.StatusClass = "tag-fail"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 1) {
              item.StatusStr = t('order.ps.charging')
              item.StatusClass = "tag-brand"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 2) {
              item.StatusStr = t('order.ps.full')
              item.StatusClass = "tag-warning"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 3) {
              item.StatusStr = t('order.ps.finished')
              item.StatusClass = "tag-success"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 4) {
              item.StatusStr = t('order.ps.depositing')
              item.StatusClass = "tag-brand"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 5) {
              item.StatusStr = t('order.ps.failed')
              item.StatusClass = "tag-fail"
            } else {
              item.StatusStr = t('order.ps.finished')
              item.StatusClass = "tag-success"
            }
            switch (item.Status) {
              case 0:
                item.payStatusStr = t('member.statuses.unpay')
                break;
              case 1:
                item.payStatusStr = t('member.statuses.paid')
                break;
              case 2:
                item.payStatusStr = t('member.statuses.returned')
                break;
              case 3:
                item.payStatusStr = t('bill.rs.refunding')
                break;
              case 4:
                item.payStatusStr = t('bill.rs.refundfail')
                break;
              default:
                item.payStatusStr = t('g.null')
            }
          })

          let excleData = [[]];
          let wscols = [];
          excleData = [[
            '订单号',
            '设备编号',
            '站点名称',
            '状态',
            '充电费用',
            '充电时长',
            '创建时间',
          ]];
          wscols = [    // 每列不同宽度px
            { wch: 10 },
            { wch: 20 },
            { wch: 15 },
            { wch: 12 },
            { wch: 12 },
            { wch: 22 },
            { wch: 22 },

          ];
          if (res && res.List) {
            for (let item of res.List) {
              let arr = [];
              arr = [
                item.OrderSn,
                item.DeviceId,
                item.DeviceSiteName,
                item.StatusStr,
                item.ChargeBatteryOrderInfo.ChargeMoney,
                item.ChargeBatteryOrderInfo.ChargeDuration,
                item.CreatedAtStr,
              ]
              excleData.push(arr)
            }
          }
          const worksheet = XLSX.utils.aoa_to_sheet(excleData);
          worksheet["!cols"] = wscols;
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          loading.close()
          XLSX.writeFile(workbook, '两轮充电桩订单记录' + '.xlsx');
        } catch {
          loading.close()
          console.log("导出失败")
        }
      },
      showDetails(row, column) {
        if (column && column.label == t('g.operation')) {
          return;
        }
        formData.dialogDisplayVisible = true;
        formData.curData = row;
      },
      getSummaries(options) {
        const { columns, data } = options;
        // console.log(JSON.stringify(options),2390);

        const sums = [];
        columns.forEach((column, index) => {

          if (index === 2) {
            sums[index] = t("g.total")
            return;
            //index === 22 || index === 24 || index === 28  这是表格第几列需要合计值
            // 例如只需要第3列的值求和，index===3
          } else if (index === 8) {
            let tmp = column.property.split('.');
            const values = data.map((item) => Number(item[tmp[0]][tmp[1]]));
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              // console.log(JSON.stringify(value),23980);
              if (!isNaN(value)) {
                return Math.floor((prev + curr) * 100) / 100;
              } else {
                return prev;
              }
            }, 0) + t('card.currency');;
          } else if (index === 9) {
            let tmp = column.property.split('.');
            const values = data.map((item) => Number(item[tmp[0]][tmp[1]]));
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              // console.log(JSON.stringify(value),23980);
              if (!isNaN(value)) {
                return Math.floor((prev + curr) * 100) / 100;
              } else {
                return prev;
              }
            }, 0) + t('g.minute');
          }
        });

        return sums;
      },
      formatSecToStr(seconds) {
        let daySec = 24 * 60 * 60;
        let hourSec = 60 * 60;
        let minuteSec = 60;
        let dd = Math.floor(seconds / daySec);
        let hh = Math.floor((seconds % daySec) / hourSec);
        let mm = Math.floor((seconds % hourSec) / minuteSec);
        let ss = seconds % minuteSec;
        if (dd > 0) {
          return dd + "天" + hh + "小时" + mm + "分钟";
        } else if (hh > 0) {
          return hh + "小时" + mm + "分钟" + ss + "秒";
        } else if (mm > 0) {
          return mm + "分钟" + ss + "秒";
        } else if (ss > 0) {
          return ss + "秒";
        }
      },
      tapStatus(data) {
        const flag = data.ChargeBatteryOrderInfo.ChargeStatus != 3
        if (!flag) {
          return
        }
        ElMessageBox.prompt(t('order.input_end_reason'), t('tips'), {
          confirmButtonText: t('confirm'),
          cancelButtonText: t('cancel'),
        })
          .then(({ value }) => {
            return axios.post("/admin/order/endBoxCharge", {
              orderId: data.Id,
              remark: value
            })
          })
          .then(() => {
            ElMessage({
              type: 'success',
              message: t('g.success')
            })
            return func.loadData()
          })
          .catch(() => {

          })
      },
      search() {
        console.log('formData', formData)
        func.loadData(1)
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      async get_pilesite() {
        let params = {
          GetAll: 0,
          DevType: 1
        }
        let res = await axios.get(`/admin/pilesite/get`, {
          params
        })
        res.List.splice(0, 0, { Name: '无', Id: 0 })
        formData.pilesiteList = res.List
      },
      refresh() {
        formData.CodePathID = 0
        formData.valStatus = 2
        formData.valTime = ''
        formData.valTel = ''
        func.loadData(1)
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.valOrderSn) {
            params.orderSn = formData.valOrderSn
          }
          if (formData.valDeviceId) {
            params.deviceId = formData.valDeviceId
          }
          if (formData.valSiteName) {
            params.siteName = formData.valSiteName
          }
          if (formData.valPhone) {
            params.phoneNum = formData.valPhone
          }
          if (formData.CodePathID) {
            params.CodePathID = formData.CodePathID
          }
          if (formData.valTel) {
            params.nickname = formData.valTel
          }
          if (formData.valStatus != 2) {
            params.status = formData.valStatus
          }
          if (formData.SiteName) {
            params.SiteName = formData.SiteName
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          params.IsStartWith = formData.IsStartWith
          let res = await axios.get(`/admin/order/spiCharge`, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreatedAt)
            item.ChargeBatteryOrderInfo.TakeBatteryTimeStr = item.ChargeBatteryOrderInfo.TakeBatteryTime ? toDay(item.ChargeBatteryOrderInfo.TakeBatteryTime) : "-"

            item.ChargeBatteryOrderInfo.StartTimeStr = item.ChargeBatteryOrderInfo.StartTime ? toDay(item.ChargeBatteryOrderInfo.StartTime) : "-"
            item.ChargeBatteryOrderInfo.EndTimeStr = item.ChargeBatteryOrderInfo.EndTime ? toDay(item.ChargeBatteryOrderInfo.EndTime) : "-"
            if (item.DeviceStatus === 0) {
              item.StatusStr = t('member.statuses.failed')
              item.StatusClass = "tag-fail"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 0) {
              item.StatusStr = t('order.ps.unresponsive')
              item.StatusClass = "tag-fail"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 1) {
              item.StatusStr = t('order.ps.charging')
              item.StatusClass = "tag-brand"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 2) {
              item.StatusStr = t('order.ps.full')
              item.StatusClass = "tag-warning"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 3) {
              item.StatusStr = t('order.ps.finished')
              item.StatusClass = "tag-success"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 4) {
              item.StatusStr = t('order.ps.depositing')
              item.StatusClass = "tag-brand"
            } else if (item.ChargeBatteryOrderInfo.ChargeStatus === 5) {
              item.StatusStr = t('order.ps.failed')
              item.StatusClass = "tag-fail"
            } else {
              item.StatusStr = t('order.ps.finished')
              item.StatusClass = "tag-success"
            }
            switch (item.Status) {
              case 0:
                item.payStatusStr = t('member.statuses.unpay')
                item.payStatusClass = "tag-brand"
                break;
              case 1:
                item.payStatusStr = t('member.statuses.paid')
                item.payStatusClass = "tag-success"
                break;
              case 2:
                item.payStatusStr = t('member.statuses.returned')
                item.payStatusClass = "tag-warning"
                break;
              case 3:
                item.payStatusStr = t('bill.rs.refunding')
                item.payStatusClass = "tag-warning"
                break;
              case 4:
                item.payStatusStr = t('bill.rs.refundfail')
                item.payStatusClass = "tag-warning"
                break;
              default:
                item.payStatusStr = t('g.null')
                item.payStatusClass = "tag-warning"
            }
            item.ImagePre = []
            if (!item.DevImageList) {
              item.DevImageList = []
            }
            item.DevImageList.map((item2) => {
              item2.TypeName = ""
              switch (item2.OperType) {
                case 0:
                  item2.TypeName = t('order.imgs.t0')
                  break
                case 1:
                  item2.TypeName = t('order.imgs.t1')
                  break
                case 2:
                  item2.TypeName = t('order.imgs.t2')
                  break
                case 3:
                  item2.TypeName = t('order.imgs.t3')
                  break
              }
              item.ImagePre.push(item2.Image)
            })
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      console.log("onMounted")
      //updateOperators()
      func.loadData()
      func.get_pilesite()
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {

  .inp-block {
    display: block;
  }

  .table-expand {
    padding-left: 4rem;
    padding-top: 1rem;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 49%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }
}
</style>
